<script>
import { blogSlider, bannerSlider, brandLogoSlider, productSliderItemFour, productSliderItemFive, tabProductsSlider } from './../../../static/js/main_vue.js';
import { LazyYoutube } from "vue-lazytube";

import { app, Location, util } from './../../functions.js';
import BannerAPI from './../../api/banner.js';
import BrandsAPI from './../../api/brands.js';
import CategoriesAPI from './../../api/categories.js';
import RecipeAPI from './../../api/recipe.js';
import ProductAPI from './../../api/product.js';

import ProductCard from './../shared/ProductCard.vue';
import HeaderThree from './../shared/HeaderThree.vue';
import Footer from './../shared/Footer.vue';
import ImageSlider from './../shared/ImageSlider.vue';
import AddToCartDialogue from './../shared/AddToCartDialogue.vue'
import QuickviewDialogue from './../shared/QuickviewDialogue.vue'

import _orderBy from 'lodash';

export default {
  name: 'Home',
  components: {
    ProductCard,
    Footer,
    HeaderThree,
    ImageSlider,
    LazyYoutube,
    AddToCartDialogue,
    QuickviewDialogue

  },
   watch: {
    ourproducts_viewcategory (new_value, old_value) {
      // Autoclose Error after 5 Seconds
      if (new_value != old_value) {
        this.loadMainCategoryProducts(new_value);
      }
    }
  },
  data () {
    return {
      app,
      banners: [],
      mini_banners: [],
      brands: [],
      main_categories: [],
      top_categories: [],
      recipes: [],
      ourproducts_viewcategory: 0,
      tab_products: [],
      special_offers: [],
      featured_products: [],
      show_all_categories: false,
      max_displayed_categories: 8,
      categoryOpen: false
    }
  },
  methods: {
    toggleCategory() {
      this.categoryOpen = !this.categoryOpen
    },
    async loadMainCategoryProducts(main_category_id)
    {
      try {
        this.tab_products = [];
        var barangay_code = Location.location.barangay.brgy_code;
        var products_request = ProductAPI.getProducts(barangay_code, '', main_category_id, '', false, false, 'best_seller', 'none', '', 12, 0, [])
          products_request.then((response) => {
          this.tab_products = response.products;
        })
      } catch (error) {
        console.log(error);

      }

    },
    async loadFeaturedProducts()
    {
      try {
        var barangay_code = Location.location.barangay.brgy_code;
        var featuredproducts_request = ProductAPI.getFeaturedProducts(barangay_code, 'homepage_featured')
          featuredproducts_request.then((response) => {
          this.featured_products = response;
          setTimeout(()=>{
            productSliderItemFour();
          },1000);
        })
      } catch (error) {
        console.log(error);

      }

    },
    async loadSpecialOffers()
    {
      try {
        var barangay_code = Location.location.barangay.brgy_code;
        var products_request = ProductAPI.getProducts(barangay_code, '', '','', true, false, 'best_seller', 'none', '', 12, 0, [])
          products_request.then((response) => {
          this.special_offers = response.products;
          setTimeout(()=>{

            productSliderItemFour();
          },1000);
        })
      } catch (error) {
        console.log(error);

      }

    },
    async loadBanners () {
      try {
        this.banners = [];
        var banner_request = BannerAPI.getBanners()
        banner_request.then((response) => {
          var bnr = _.orderBy(response, ['order_by'],['asc']);
          var temp = [];
          bnr.forEach((b,b_index)=>{
            if(b.image_desktop_filename != null)
            {
              temp.push(b);
            }
          });

          this.banners = temp;
          setTimeout(()=>{
            bannerSlider();
          },1000);
        })
      } catch (error) {

      }
    },
    async loadMiniBanners () {
      try {
        var minibanner_request = BannerAPI.getMiniBanners()
        minibanner_request.then((response) => {
          this.mini_banners =  _.orderBy(response, ['order_by'],['asc']);
        })
      } catch (error) {

      }
    },
    async loadBrands () {
      try {
        var barangay_code = Location.location.barangay.brgy_code;
        var brands_request = BrandsAPI.getBrands(barangay_code)
        brands_request.then((response) => {
          // if (response.status == 'success') {
            this.brands =  _.orderBy(response.brands, ['order_by'],['asc'])
     
           setTimeout(()=>{
            
            brandLogoSlider();
          },1000);
          // }
        })
      } catch (error) {

      }
    },
    async loadMainCategories () {
      try {
        var barangay_code = Location.location.barangay.brgy_code;
        var main_category_request = CategoriesAPI.getMainCategories(barangay_code)
        main_category_request.then((response) => {
          this.main_categories =  _.orderBy(response.main_categories, ['order_by'],['asc']);
          this.top_categories   = response.top_categories;

          if(this.main_categories.length)
          {
            this.ourproducts_viewcategory = this.main_categories[0].main_category_id;
            this.loadMainCategoryProducts(this.ourproducts_viewcategory);
          }


        })
      } catch (error) {

      }
    },
    async loadRecipes () {
      try {
        this.recipes = [];
       var recipe_request = RecipeAPI.getRecipes()
        recipe_request.then((response) => {
            
          if(response.length)
          {
            this.recipes = response;

               setTimeout(()=>{
            
                blogSlider();
              },1000);
          }

        })
      } catch (error) {
          console.log(error);
      }
    },
    goToShop(banner)
    {
      var banner_group_name = banner.banner_title.toLowerCase();
      var linked_products = banner.linked_products;
    
      var data = {
        name: banner.banner_title,
        slug: util.convertToSlug(banner.banner_title),
        products: linked_products 
      };
       
       if(linked_products.length)
       {

         sessionStorage.setItem('gsm_vc', JSON.stringify(data));
         this.$router.push({ path: "/shop", query: { 'collection': data.slug } });

       }

    },
    moreCategories()
    {
      this.show_all_categories = true;
      this.max_displayed_categories = this.main_categories.length;
    },
    closeCategoryMenu ()
    {
      this.show_all_categories  = false;
      this.max_displayed_categories = 8;
    }
    
   

  },
  mounted () {

    this.loadBanners();
    this.loadMiniBanners();
    this.loadMainCategories();
    this.loadBrands();
    this.loadRecipes();
    this.loadSpecialOffers();
    this.loadFeaturedProducts();

    console.log(this.$refs);
  }
}
</script>

<template>
  <div class="page home-page">
    <HeaderThree />

    <!-- SLIDER AREA START (slider-3) -->
    <div class="ltn__slider-area ltn__slider-area-1 ltn__slider-3---  section-bg-1--- mt-30">
        <div class="container">
            <div class="row">
                <div class="col-lg-3">
                    <!-- CATEGORY-MENU-LIST START -->
                        <div class="ltn__category-menu-wrap" @click="toggleCategory">
                            <div class="ltn__category-menu-title">
                                <h2 class="section-bg-2--- primary-bg text-color-white">categories</h2>
                            </div>
                                <div :style="{ maxHeight: categoryOpen ? '350px' : '0' }" :class="['ltn__category-menu-toggle ltn__one-line-active']">                                
                                  <ul v-if="main_categories.length">
                                  
                                    <li class="ltn__category-menu-item pl ltn__category-menu-drop " v-for="category in main_categories.slice(0,max_displayed_categories)">
                                        <router-link :to="{ path: '/shop', query: { category: category.main_category_id }}">
                                         <!--<img class="category-icons" :src="category.main_category_icon"> -->
                                        {{ category.main_category_name }}</router-link>
                                        <ul class="ltn__category-submenu ltn__category-column-no-1" v-if="category.sub_categories.length">
                                            <li class="" v-for="sub_category in category.sub_categories">
                                              <router-link :to="{ path: '/shop', query: { category: category.main_category_id, sub_category: sub_category.id }}" >{{ sub_category.category_name }}</router-link>
                                               <!--  <ul class="ltn__category-submenu-children">
                                                    <li><a href="#">Clutches Clutches Clutches Clutches </a></li>
                                                    <li><a href="#">Cross Body</a></li>
                                                    <li><a href="#">Satchels</a></li>
                                                    <li><a href="#">Sholuder</a></li>
                                                    <li><a href="#">Toter</a></li>
                                                </ul> -->
                                            </li>
                                        </ul>
                                    </li>
                                      
                                     <li class="ltn__category-menu-more-item-parent">
                                        <router-link to="/shop" class="rx-default">
                                            See All Products <span class="cat-thumb  icon-plus"></span> 
                                        </router-link>
                                       
                                    </li>
                                    <!-- <li class="ltn__category-menu-more-item-parent" v-if="main_categories.length > 8">
                                        <a class="rx-default" @click="moreCategories" v-if="!show_all_categories">
                                            More Categories <span class="cat-thumb  icon-plus"></span> 
                                        </a>
                                        <a class="rx-default" @click="closeCategoryMenu" v-if="show_all_categories">
                                            Close Menu <span class="cat-thumb  icon-remove"></span>
                                        </a>
                                    </li> -->
                                    <!-- Single menu end -->
                                </ul>
                            </div>
                        </div>
                    <!-- END CATEGORY-MENU-LIST -->
                </div>
                <div class="col-lg-9 slider-container" v-if="banners.length">
                    <div class="ltn__slide-active-2 slick-slide-arrow-1 slick-slide-dots-1">
                   
                        <div class="ltn__slide-item ltn__slide-item-10 section-bg-1 bg-image" :data-order="banner.order_by" v-for="banner in banners" :data-bg="banner.image_desktop_filename.filename" @click="goToShop(banner)">
                            <div class="ltn__slide-item-inner">
                                <div class="container">
                                    <div class="row">
                                        <div class="col-lg-7 col-md-7 col-sm-7 align-self-center">
                                            <div class="slide-item-info">
                                                <div class="slide-item-info-inner ltn__slide-animation">
                                                    <!-- <h5 class="slide-sub-title ltn__secondary-color animated text-uppercase">Up To 50% Off Today Only!</h5>
                                                    <h1 class="slide-title  animated">Tasty & Healthy <br>  Organic Food</h1>
                                                    <div class="slide-brief animated d-none">
                                                        <p>Predictive analytics is drastically changing the real estate industry. In the past, providing data for quick</p>
                                                    </div>
                                                    <div class="btn-wrapper  animated">
                                                        <a href="shop.html" class="theme-btn-1 btn btn-effect-1 text-uppercase">Shop now</a>
                                                    </div> -->
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-5 col-md-5 col-sm-5 align-self-center">
                                            <div class="slide-item-img">
                                                <!-- <a href="shop.html"><img src="img/product/1.png" alt="Image"></a> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <ImageSlider v-if="banners.length" :images="banners" /> -->
                </div>
            </div>
        </div>
    </div>
    <!-- SLIDER AREA END -->

    <!-- BANNER AREA START -->
    <div class="ltn__banner-area mt-120" v-if="mini_banners.length">
        <div class="container">
            <div class="row ltn__custom-gutter--- justify-content-center">
                <div class="col-lg-4 col-md-6" :data-order="mini.order_by" v-for="mini in mini_banners">
                    <div class="ltn__banner-item">
                        <div class="ltn__banner-img">
                            <img :src="mini.image_desktop_filename" class="d-none d-lg-block" alt="Banner Image" @click="goToShop(mini)">
                            <img :src="mini.image_tablet_filename" class="d-none d-md-block d-lg-none" alt="Banner Image" @click="goToShop(mini)">
                            <img :src="mini.image_mobile_filename" class="d-block d-md-none" alt="Banner Image" @click="goToShop(mini)">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- BANNER AREA END -->

    <!-- CATEGORY AREA START -->
    <div class="ltn__category-area section-bg-1--- pt-80 pb-85 top-categories">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title-area ltn__section-title-2 text-center">
                        <h1 class="section-title white-color---">Top Categories</h1>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center ltn__category-slider-active--- slick-arrow-1">
                <div class="col-lg-3 col-md-4 col-sm-6 col-6" v-for="cat in top_categories">
                    <div class="ltn__category-item ltn__category-item-3 text-center">
                        <div class="ltn__category-item-img">
                            <router-link :to="{ path: '/shop', query: { category: cat.main_category_id }}">
                                <img :src="cat.main_category_image" alt="Image" class="main-category-image">
                            </router-link>
                        </div>
                        <div class="ltn__category-item-name">
                            <h5><router-link :to="{ path: '/shop', query: { category: cat.main_category_id }}">{{ cat.main_category_name }}</router-link></h5>
                            <h6>({{ cat.item_count }} {{ cat.item_count > 1 ? 'Items' : 'Item'}})</h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- CATEGORY AREA END -->

    <!-- COUNTDOWN AREA START -->
    <div class="ltn__call-to-action-area ltn__call-to-action-4 ltn__call-to-action-4-2 section-bg-1 pt-110 pb-120 mt-120---">
       <router-link :to="{ path: '/shop', query: { sale: '1' }}">
        <img src="@/assets/hot-deals.png" alt="#">
        </router-link>
     
    </div>
    <!-- COUNTDOWN AREA END -->

    <!-- PRODUCT TAB AREA START (product-item-3) -->
    <div class="ltn__product-tab-area ltn__product-gutter pt-115 pb-70">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title-area ltn__section-title-2 text-center">
                        <!-- <h6 class="section-subtitle ltn__secondary-color">// Cars</h6> -->
                        <h1 class="section-title white-color---">Our Products</h1>
                    </div>
                    <div class="ltn__tab-menu ltn__tab-menu-2 ltn__tab-menu-top-right-- text-uppercase text-center">
                        <div class="nav">
                            <!-- <a  data-toggle="tab" href="#liton_tab_3_1">Food & Drinks</a> -->
                            <a  @click="ourproducts_viewcategory = cat.main_category_id" :class="{ 'active show': ourproducts_viewcategory == cat.main_category_id }" v-for="cat in main_categories.slice(0,5)">{{cat.main_category_name}}</a>
                        </div>
                    </div>
                    <div class="tab-content">
                        <div class="tab-pane fade active show" id="liton_tab_3_1">
                            <div class="ltn__product-tab-content-inner">
                                <div class="row ltn__tab-product-slider-one-active slick-arrow-1">
                                    <!-- ltn__product-item -->
                                    <div class="col-lg-3 col-6" v-for="tab_product of tab_products">
                                           <ProductCard
                                            :product="tab_product"
                                            :id="tab_product.id"
                                            :name="tab_product.title"
                                            :badge="tab_product.discountPercentage"
                                            :rating="tab_product.rating"
                                            :price="tab_product.price"
                                            :sale-price="tab_product.price"
                                            @onQuickview="quickview(product)"
                                            @onAddToCart="showModal()"
                                            @onAddToWishlist="showModal()" />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- PRODUCT TAB AREA END -->


    <!-- PRODUCT SLIDER AREA START -->
    <div class="ltn__product-slider-area ltn__product-gutter pt-80 pb-70" v-if="special_offers.length">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title-area ltn__section-title-2--- text-center">
                        <h1 class="section-title">Special Offers</h1>
                    </div>
                </div>
            </div>
            <div class="row ltn__product-slider-item-four-active slick-arrow-1">
                <!-- ltn__product-item -->
                <div class="col-lg-12" v-for="deal_product of special_offers">
                    <ProductCard
                      :product="deal_product"
                      @onQuickview="quickview(product)"
                      @onAddToCart="showModal()"
                      @onAddToWishlist="showModal()" />
                </div>
               
            </div>
        </div>
    </div>
    <!-- PRODUCT SLIDER AREA END -->

     <!-- PRODUCT SLIDER AREA START -->
    <div class="ltn__product-slider-area ltn__product-gutter pt-80 pb-70 " v-if="featured_products.length">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title-area ltn__section-title-2--- text-center">
                        <h1 class="section-title white-color---">Featured Products</h1>
                    </div>
                </div>
            </div>
            <div class="row ltn__product-slider-item-four-active slick-arrow-1">
                <!-- ltn__product-item -->
                <div class="col-lg-12" v-for="featured of featured_products">
                    <ProductCard
                      :product="featured"
                      @onQuickview="quickview(product)"
                      @onAddToCart="showModal()"
                      @onAddToWishlist="showModal()" />
                </div>
               
            </div>
        </div>
    </div>
    <!-- PRODUCT SLIDER AREA END -->

    <!-- BRAND LOGO AREA START -->
    <div class="ltn__brand-logo-area ltn__brand-logo-1 section-bg-6 border-top border-bottom pt-35 pb-35 plr--9 ">
        <div class="container-fluid">
            <div class="row ltn__brand-logo-active">
                <div class="col-lg-12" v-for="brand in brands">
                    <div class="ltn__brand-logo-item">
                       <router-link :to="{ path: '/shop', query: { brand: brand.brand_id }}"> <img :src="brand.brand_image" alt="Brand Logo"></router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- BRAND LOGO AREA END -->

    <!-- BLOG AREA START (blog-3) -->
    <div class="ltn__blog-area pt-115 pb-70" v-if="recipes.length">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title-area ltn__section-title-2 text-center">
                        <h1 class="section-title white-color---">Latest Blogs</h1>
                    </div>
                </div>
            </div>
            <div class="row  ltn__blog-slider-one-active slick-arrow-1 ltn__blog-item-3-normal">
                <!-- Blog Item -->
                <div class="col-lg-12"  v-for="recipe in recipes">
                    <div class="ltn__blog-item ltn__blog-item-3">
                       <LazyYoutube :src="recipe.youtube_link" />
                        <!-- {{ recipe.youtube_link }} -->
                    </div>
                </div>

            </div>
        </div>
    </div>
    <!-- BLOG AREA END -->

   <Footer />
   <AddToCartDialogue ref="addToCartDialogue" />
   <QuickviewDialogue ref="quickviewDialogue" />
  </div>
</template>
<style scoped>
@media screen and (min-width: 992px)
{
  .ltn__call-to-action-area.ltn__call-to-action-4.ltn__call-to-action-4-2.section-bg-1.pt-110.pb-120.mt-120--- {
      padding: 0;
      max-height: 400px;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
  }
}
.ltn__category-submenu {
    width: 100% !important;
}
</style>


// WEBPACK FOOTER //
// src/components/page/Home.vue